import BaseShareTask from "../baseShareTask";

export default class BaseShareOnModal extends BaseShareTask {
  ReseanOnChange = (e: any) => {
    this.setState({
      reseanValue: e.value,
      reasonInputStatus: "",
    });
  };
}
